import { IEditLeadPayload, IGetLeadList, ILeadCreate, ILeadDetails, ILeadListSearch } from "../../../types/sales/leadInterface";
import { IGetMyLeadList, IMyLeadDetails, IMyLeadListSearch } from "../../../types/sales/myLeadInterface";
import { LeadActionTypes, LeadActions } from "../../actionTypes/sales/leadActionTypes";

export const createLead = (payload: ILeadCreate): LeadActionTypes => ({
  type: LeadActions.CREATE_LEAD,
  payload,
});

export const getLeadList = (payload: ILeadListSearch): LeadActionTypes => ({
  type: LeadActions.GET_LEAD_LIST,
  payload,
});
export const getMyLeadList = (payload: IMyLeadListSearch): LeadActionTypes => ({
  type: LeadActions.GET_MY_LEAD_LIST,
  payload,
});

export const setLeadList = (payload: Array<IGetLeadList>) : LeadActionTypes => ({
  type: LeadActions.SET_LEAD_LIST,
  payload: payload
})

export const setMyLeadList = (payload: Array<IGetMyLeadList>) : LeadActionTypes => ({
  type: LeadActions.SET_MY_LEAD_LIST,
  payload: payload
})

export const setLeadListPageCount = (payload:number): LeadActionTypes => ({
  type: LeadActions.SET_LEAD_LIST_PAGE_COUNT,
  payload
})
export const setMyLeadListPageCount = (payload:number): LeadActionTypes => ({
  type: LeadActions.SET_MY_LEAD_LIST_PAGE_COUNT,
  payload
})

export const getLeadDataById = (id: number): LeadActionTypes => ({
  type: LeadActions.GET_LEAD_DATA_BY_ID,
  payload: id
})

export const getMyLeadDataById = (id: number): LeadActionTypes => ({
  type: LeadActions.GET_MY_LEAD_DATA_BY_ID,
  payload: id
})

export const setLeadDataById = (payload: ILeadDetails) => ({
  type: LeadActions.SET_LEAD_DATA_BY_ID,
  payload
})

export const setMyLeadDataById = (payload: IMyLeadDetails) => ({
  type: LeadActions.SET_MY_LEAD_DATA_BY_ID,
  payload
})

export const editLead = (payload: IEditLeadPayload) => ({
  type: LeadActions.EDIT_LEAD_DATA_BY_ID,
  payload,
});

export const deleteSalesLead = (id: number) => ({
  type: LeadActions.DELETE_LEAD,
  payload: id,
});

